export default {"src":"/_next/static/media/PROFILE_ICON_FILLED_GREY.5c38e825.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};